import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Notifications } from '@/pet/src/components/Notifications';
import { usePets } from '@/pet/src/context/PetsContext';

export const Route = createFileRoute('/dashboard/notifications')({
  component: PetsoNotifications,
});

function PetsoNotifications() {
  const navigate = useNavigate();
  const { setSelectedPetId } = usePets();

  return (
    <Notifications
      onClose={() => navigate({ to: '/dashboard' })}
      onNavigateToPendingApprovals={(petId) => {
        setSelectedPetId(petId);
        navigate({ to: '/dashboard/family' });
      }}
    />
  );
}
